<!--标题栏-->
<template>
  <div v-show="title" class="fin-nav">
    <div class="fin-nav__title">{{ title }}</div>
    <svg class="fin-nav__back" viewBox="0 0 1000 1000" @click="onBack">
      <path fill="#969799" fill-rule="evenodd" :d="path" />
    </svg>
  </div>
</template>

<script>
/* eslint-disable max-len */
export default {
	props:{
		title: String
	},
  data() {
    return {
      path:
        'M296.114 508.035c-3.22-13.597.473-28.499 11.079-39.105l333.912-333.912c16.271-16.272 42.653-16.272 58.925 0s16.272 42.654 0 58.926L395.504 498.47l304.574 304.574c16.272 16.272 16.272 42.654 0 58.926s-42.654 16.272-58.926 0L307.241 528.058a41.472 41.472 0 0 1-11.127-20.023z',
    };
  },


  methods: {
    onBack() {
      history.back();
    },
  },
};
</script>

<style lang="less">
.fin-nav {
  position: relative;
  height: 56px;
  line-height: 56px;
  text-align: center;
  background-color: #fff;

  &__title {
    font-weight: 500;
    font-size: 17px;
    text-transform: capitalize;
  }

  &__back {
    position: absolute;
    top: 16px;
    left: 16px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}
</style>
